/**
 * Sovereign Admin Copilot API Client Service
 * EPIC-OPS-003 / STORY-OPS-003.3
 */

import api from './api';

export interface CopilotQueryPayload {
  query: string;
  scope?: 'PK' | 'UAE' | 'ALL';
}

export interface CopilotQueryResponse {
  answer: string;
  scope: ('PK' | 'UAE')[];
  latencyMs: number;
  dataAsOf: string;
}

export interface CopilotApiError {
  status: string;
  code: string;
  message: string;
  statusCode?: number;
}

export const queryAssistant = async (
  payload: CopilotQueryPayload
): Promise<CopilotQueryResponse> => {
  try {
    const response = await api.post<CopilotQueryResponse>(
      '/admin/assistant/query',
      payload,
      { timeout: 300000 }
    );
    return response.data;
  } catch (error: any) {
    const errorData: CopilotApiError = {
      status: error.response?.data?.status || 'fail',
      code: error.response?.data?.code || (error.response?.status === 503 ? 'COPILOT_LOCAL_MODEL_UNAVAILABLE' : 'COPILOT_QUERY_ERROR'),
      message: error.response?.data?.message || error.message || 'Error communicating with Sovereign Copilot.',
      statusCode: error.response?.status || 500
    };
    throw errorData;
  }
};
